
    <div
      class="inline-flex w-fit max-w-full rounded-lg bg-gray-100 p-0.5 dark:bg-gray-900
      overflow-x-auto
      [&::-webkit-scrollbar]:h-1.5 
      [&::-webkit-scrollbar-track]:bg-white 
      dark:[&::-webkit-scrollbar-track]:bg-transparent 
      [&::-webkit-scrollbar-thumb]:rounded-full 
      [&::-webkit-scrollbar-thumb]:bg-gray-200 
      dark:[&::-webkit-scrollbar-thumb]:bg-gray-600"
    >
      @for (item of items(); track item.key) {
      <button
        (click)="setActiveItem(item.key)"
        [disabled]="isDisabled || item.disabled"
        class="disabled:text-gray-400
    disabled:cursor-not-allowed
    disabled:opacity-60"
        [ngClass]="[
          'inline-flex items-center rounded-md px-3 py-2 font-title text-sm font-medium transition-colors duration-200 ease-in-out',
          activeItem === item.key
            ? 'bg-white text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 shadow dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/3 dark:hover:text-gray-300'
            : 'bg-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
        ]"
      >
        <span class="whitespace-nowrap overflow-hidden text-ellipsis max-w-[8rem]">
          {{ item.label }}
        </span>
      </button>
      }
    </div>
